<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <button mat-raised-button routerLink="/sites" class="m-1 mr-2">
    <mat-icon>arrow_back</mat-icon> {{ utils.getLangTerm('sites.plural', 'Sites') }}
  </button>

  <button mat-raised-button *ngIf="child_id" [routerLink]="'/sites/'+parent_id+'/children'" class="m-1 mr-2">
    <mat-icon>arrow_back</mat-icon> {{ utils.getLangTerm('child-sites.plural', 'Subsites') }}
  </button>

  <button mat-raised-button [routerLink]="utils.prepareSiteRelatedLink(site_id, child_id ? parent_id : null, 'edit/codes')" class="m-1 mr-2">
    <mat-icon>arrow_back</mat-icon> QR Codes
  </button>

  <button
    mat-raised-button
    [routerLink]="utils.prepareSiteRelatedLink(site_id, child_id ? parent_id : null, 'edit/codes/' + code.id + '/view')"
    *ngIf="code.id"
    class="m-1 mr-2">
    <mat-icon>visibility</mat-icon>
    View
  </button>

  <button
    mat-raised-button
    (click)="onRemove()"
    *ngIf="code.id"
    color="warn"
    class="m-1 mr-2">
    <mat-icon>delete</mat-icon>
    Delete
  </button>
</nav>

<div class="container-fluid p-0">

  <div class="card rounded-0">
    <div class="card-body">

        <div class="row">
          <div class="col">
            <form #f="ngForm" class="form-container" (ngSubmit)="onSubmit(f)">
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title">Codes Form</h5>

                  <div class="row pt-3">
                    <div class="col">
                      <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                        <mat-label>Features</mat-label>
                        <mat-select placeholder="Features" [(ngModel)]="code.feature" name="feature" required>
                          <mat-option *ngFor="let feature of features" [value]="feature">
                            {{ feature }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div class="col">
                      <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                        <mat-label>Type</mat-label>
                        <mat-select placeholder="Type" [(ngModel)]="code.type" name="type" required>
                          <mat-option *ngFor="let type of types[code.feature]" [value]="type">
                            {{ type }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>

                  <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                    <mat-label>Name</mat-label>
                    <input
                      matInput
                      placeholder="Name"
                      [(ngModel)]="code.name"
                      name="name"
                      type="text"
                      #name
                      required/>
                    <mat-error *ngIf="!name.valid">Please enter a Name.</mat-error>
                  </mat-form-field>

                  <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                    <mat-label>Message</mat-label>
                    <textarea
                      matInput
                      placeholder="Message"
                      [(ngModel)]="code.message"
                      name="message"
                      #message
                      rows="10">
                    </textarea>
                    <mat-error *ngIf="!message.valid">Please enter a message.</mat-error>
                  </mat-form-field>

                  <div class="row">
                    <div class="col">
                      <button
                        type="button"
                        mat-raised-button
                        [disabled]="!f.valid || inProgress"
                        class="my-2 ml-0 mr-2"
                        color="primary"
                        (click)="onSubmit(f)">
                        <mat-icon>save</mat-icon>
                        Save
                      </button>
                    </div>
                  </div>

                </div>
              </div>
            </form>
          </div>

          <div class="col">
            <h6>Instructions</h6>
            <p>
              Complete the form on the left to add a new or update an existing QR
              code.
            </p>
            <p>
              QR codes can be placed at {{ utils.getLangTerm('parent-child-sites-combined.plural', 'Sites').toLowerCase() }} for {{ utils.getLangTerm('contractors.singular', 'Contractor') }} and {{ utils.getLangTerm('employees.plural', 'Employees') }}
              to scan.
            </p>
            <p>
              QR codes can contain confidential information. Only {{ utils.getLangTerm('contractors.singular', 'Contractor') }} and {{ utils.getLangTerm('employees.plural', 'Employees') }} that have access to your {{ utils.getLangTerm('parent-child-sites-combined.plural', 'Sites').toLowerCase() }} can see the
              information.
            </p>
            <p>
              Enter a Name and a message. When the QR code is scanned,
              the person scanning it will see the information.
            </p>
            <p>
              There are various types of QR codes available namely in, out, in/out and
              location under access control.
            </p>
            <p>
              Scanning an <b>in</b> QR code will sign the {{ utils.getLangTerm('contractors.singular', 'Contractor') }} or
              {{ utils.getLangTerm('employees.plural', 'Employees') }} in.
            </p>
            <p>
              Scanning an <b>out</b> QR code will sign the {{ utils.getLangTerm('contractors.singular', 'Contractor') }} or
              {{ utils.getLangTerm('employees.plural', 'Employees') }} out.
            </p>
            <p>
              Scanning an <b>in/out</b> QR code will either scan the {{ utils.getLangTerm('contractors.singular', 'Contractor') }} or {{ utils.getLangTerm('employees.plural', 'Employees') }} in or out depending on their current sign-in status.
            </p>
            <p>
              Scanning the <b>location</b> QR code will mark the {{ utils.getLangTerm('contractors.singular', 'Contractor') }}
              or {{ utils.getLangTerm('employees.singular', 'Employee') }}'s location.
            </p>
          </div>
        </div>

    </div>

  </div>
</div>
